// Move custom text field to appear after quantity selector and add debugging
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 Debug: DOM loaded, searching for elements...');
  
  const customTextField = document.querySelector('.product-form__custom-text');
  const quantitySelector = document.querySelector('[id^="Quantity-Form-"]');
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const addToCartButtons = document.querySelector('.product-form__buttons');
  
  console.log('🔍 Custom text field found:', customTextField);
  console.log('🔍 Quantity selector found:', quantitySelector);
  console.log('🔍 Product form found:', productForm);
  console.log('🔍 Add to cart buttons found:', addToCartButtons);
  
  // Check metafield debug info
  const debugElement = document.querySelector('[data-allow-custom-text]');
  if (debugElement) {
    const allowCustomText = debugElement.getAttribute('data-allow-custom-text');
    const textLabel = debugElement.getAttribute('data-text-label');
    console.log('🔍 Metafield allow_custom_text:', allowCustomText);
    console.log('🔍 Metafield text_label:', textLabel);
  }
  
  const debugReason = document.querySelector('[data-debug-reason]');
  if (debugReason) {
    console.log('❌ Field not showing, reason:', debugReason.getAttribute('data-debug-reason'));
  }
  
  if (customTextField && quantitySelector && addToCartButtons && productForm) {
    console.log('✅ Moving custom text field between quantity and add to cart button');
    
    try {
      // Insert the custom field right before the add to cart buttons
      // This ensures it appears after quantity but before the button
      addToCartButtons.parentNode.insertBefore(customTextField, addToCartButtons);
      console.log('✅ Field moved successfully between quantity and button');
      
      // Verify it's still inside the form
      if (productForm.contains(customTextField)) {
        console.log('✅ Confirmed: Custom field is inside the form');
      } else {
        console.log('❌ WARNING: Field moved outside form, repositioning...');
        productForm.insertBefore(customTextField, addToCartButtons);
      }
    } catch (error) {
      console.log('❌ Error moving field:', error);
      // Fallback: put it before buttons but ensure it's in the form
      if (productForm.contains(addToCartButtons)) {
        productForm.insertBefore(customTextField, addToCartButtons);
        console.log('✅ Field added before buttons as fallback');
      }
    }
  } else {
    console.log('❌ Elements not found for positioning');
    console.log('Missing:', {
      customTextField: !customTextField,
      quantitySelector: !quantitySelector, 
      addToCartButtons: !addToCartButtons,
      productForm: !productForm
    });
  }
  
  // Add form submission logging
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      console.log('🚀 Form submission detected');

      const formData = new FormData(productForm);
      console.log('📝 Form data:');
      
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      // Check specifically for our custom field
      const bannerText = formData.get('properties[Banner Text]');
      const debugField = formData.get('properties[_debug]');

      console.log('🎯 Banner Text value:', bannerText);
      console.log('🎯 Debug field value:', debugField);

      if (!bannerText && !debugField) {
        console.log('⚠️ WARNING: Custom fields not found in form data!');

        // Check if field exists in DOM but not in form
        const fieldInDom = document.querySelector('[data-debug="custom-text-field"]');
        if (fieldInDom) {
          console.log('🔍 Field exists in DOM:', fieldInDom);
          console.log('🔍 Field form attribute:', fieldInDom.form);
          console.log('🔍 Field inside form?', productForm.contains(fieldInDom));
        }
      }
    });
  }
});